import React from "react";
import greyLoadingImageUrl from "loading-grey.svg";
import styles from "components/common/loading.scss";

export const Loading = () => (
  <span className={ styles.loading }>
    <img alt="Loading" className={ styles.spinner } src={ greyLoadingImageUrl } />
  </span>
 );



// WEBPACK FOOTER //
// ./src/js/components/common/loading.jsx